<template>
  <div class="p-profile-details">
    <!--TODO: Add el-scrollbar-->
    <div class="p-profile-details__card">
      <company-card />
    </div>
    <div class="p-profile-details__card">
      <contact-list-card
        :hidden-columns="['phone', 'jobTitle']"
        is-alert-shown
      />
    </div>
  </div>
</template>

<script>
import CompanyCard from '@/app/components/profile/CompanyCard';
import ContactListCard from '@/app/components/profile/ContactListCard';

export default {
  name: 'Profile',
  components: {
    CompanyCard,
    ContactListCard
  }
};
</script>

<style lang="scss" scoped>
.p-profile-details {
  height: 100%;
  padding: 24px;
  overflow: auto;

  &__card {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
